import React from 'react';
import { Box, BoxProps, styled, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from './Sidebar';
import { Logout } from '@components';

const SIDEBAR_WIDTH = 320;
const CONTENT_WIDTH = 480;

interface iLayout extends BoxProps {
  children: React.ReactNode;
}

const MuiLayout = styled(Box)(({ theme }) => ({
  position: 'relative',
  paddingLeft: SIDEBAR_WIDTH,
  minHeight: '100vh',
  maxWidth: SIDEBAR_WIDTH + CONTENT_WIDTH,
  backgroundColor: theme.palette.background.paper,

  // responsive
  [theme.breakpoints.down('md')]: {
    paddingLeft: 0,
    padding: theme.spacing(2.5, 2),
    maxWidth: CONTENT_WIDTH,
    margin: '0 auto',
  },
}));

const MuiContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(7, 5),
  paddingLeft: 0,

  // Responsive
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2.5, 2),
  },
}));

const LogoutWrap = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  right: 0,
  padding: theme.spacing(0.5, 1.5),
  borderTopLeftRadius: 4,
  borderBottomLeftRadius: 4,
  zIndex: 9,
  // boxShadow: '0 0 4px 2px rgba(0, 0, 0, 0.1)',
}));

const ObLayout: React.FC<iLayout> = ({ children, ...props }) => {
  const theme = useTheme();
  const medium = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <MuiLayout {...props}>
      {medium ? (
        <Sidebar />
      ) : (
        <LogoutWrap>
          <Logout />
        </LogoutWrap>
      )}
      <MuiContent>{children}</MuiContent>
    </MuiLayout>
  );
};

export default ObLayout;
